import { JobseekerFile } from './jobseeker-file';
import { LanguageProficiencyLevelModel } from '../../../shared/models/language-proficiency-level-model';
import { WorldLanguageModel } from '../../../shared/models/world-language-model';
import { Serializable } from '../../../core/models/serializable';
export class JobseekerLanguageModel
  implements Serializable<JobseekerLanguageModel>
{
  fromObject(obj: any): JobseekerLanguageModel {
    Object.assign(this, obj);

    return this;
  }
  toObject() {
    throw new Error('Method not implemented.');
  }

  public jobseekerLanguageId: number;
  public jobseekerId: number;
  public worldLanguage: WorldLanguageModel;
  public languageProficiencyLevel: LanguageProficiencyLevelModel;
  public attachment: JobseekerFile;
}
